var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bar-chart',{attrs:{"width":150,"chart-data":_vm.dataCollection,"options":_vm.chartOptions,"styles":_vm.chartStyles}})
}
var staticRenderFns = []

export { render, staticRenderFns }